import { Reveal, SectionHeading } from "./Reveal";
import { FOUNDERS } from "../../data/content";

const FounderCard = ({ founder, flip }) => {
  const navy = founder.tone === "navy";
  return (
    <Reveal>
      <div
        className={`rounded-[2rem] overflow-hidden border grid md:grid-cols-[340px_1fr] ${
          navy
            ? "bg-gradient-to-br from-brand-sky-soft to-white dark:from-[#0D1434] dark:to-brand-ink border-slate-100 dark:border-white/10"
            : "bg-gradient-to-br from-slate-50 to-white dark:from-[#0A1030] dark:to-brand-ink border-slate-100 dark:border-white/10"
        } ${flip ? "md:[direction:rtl]" : ""}`}
        data-testid={`founder-card-${founder.name.split(" ")[1]?.toLowerCase()}`}
      >
        <div className="relative spotlight [direction:ltr]">
          <img
            src={founder.photo}
            alt={`Portrait of ${founder.name}`}
            loading="lazy"
            decoding="async"
            className="w-full h-72 md:h-full object-cover object-top md:[clip-path:polygon(0_0,100%_0,88%_100%,0_100%)]"
            style={flip ? { clipPath: undefined } : undefined}
          />
        </div>
        <div className="p-8 md:p-12 [direction:ltr]">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-sky mb-2">{founder.role}</p>
          <h3 className="font-display text-2xl md:text-3xl font-semibold text-slate-900 dark:text-white">{founder.name}</h3>
          <p className="mt-1 text-sm font-semibold text-slate-500 dark:text-slate-400">{founder.focus}</p>
          <ol className="mt-8 space-y-6">
            {founder.milestones.map((m) => (
              <li key={m.year} className="relative pl-8">
                <span className={`absolute left-0 top-1.5 w-3 h-3 rounded-full ${navy ? "bg-brand-navy dark:bg-brand-sky" : "bg-brand-sky"} ring-4 ring-brand-sky/15`} />
                <p className="text-[11px] font-black uppercase tracking-[0.2em] text-brand-navy dark:text-brand-sky">{m.year}</p>
                <p className="mt-1 text-sm leading-relaxed text-slate-600 dark:text-slate-300">{m.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </Reveal>
  );
};

const Founders = () => (
  <section id="founders" className="bg-white dark:bg-brand-ink py-24 md:py-32" data-testid="founders-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        id="founders"
        overline="Meet the Founders"
        title={<>Clinicians and operators. <span className="text-brand-gradient">One shared obsession.</span></>}
        sub="Medlyn 360 pairs deep clinical documentation expertise with two decades of service operations — so quality scales instead of slipping."
      />
      <div className="mt-14 space-y-10">
        {FOUNDERS.map((f, i) => (
          <FounderCard key={f.name} founder={f} flip={i % 2 === 1} />
        ))}
      </div>
      <Reveal delay={0.15}>
        <div className="mt-20 max-w-3xl mx-auto text-center" data-testid="shared-vision">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-sky mb-5">Shared Vision</p>
          <blockquote className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-slate-900 dark:text-white leading-snug">
            "Physicians should spend more time with patients — <span className="text-brand-gradient">not paperwork."</span>
          </blockquote>
          <p className="mt-6 text-base leading-relaxed text-slate-600 dark:text-slate-300">
            We built Medlyn 360 by combining clinical expertise, operational excellence, and technology-enabled
            workflows — to reduce the documentation burden, improve workflow efficiency, support accurate clinical
            documentation, and let providers focus on what only they can do: exceptional patient care.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
export default Founders;
